export const boxSizes = {
  country: 'w-16 sm:w-24 lg:w-30',
  hairColour: 'w-16 sm:w-24 lg:w-30',
  activity: 'w-16 sm:w-24 lg:w-30',
  year: 'w-16 sm:w-24 lg:w-30',
  invitedBy: 'w-16 sm:w-24 lg:w-30',
  favouriteGames: 'w-20 sm:w-32 lg:w-70',
};
